/**
 * Clone utility function
 * 
 * Deep clones an object/array for use in undo/redo system.
 * Ported from clone.as
 */

export function clone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    
    if (obj instanceof Array) {
        return obj.map(item => clone(item));
    }
    
    if (typeof obj === 'object') {
        const cloned = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                cloned[key] = clone(obj[key]);
            }
        }
        return cloned;
    }
    
    return obj;
}

